import React from "react";
import { OperationalCircleMetric } from "../../../../../Components/Cards";

type MetricStatus = "default" | "success" | "warning" | "processing" | "error";

interface OperationalMetricCardProps {
  readonly percent: number;
  readonly color: string;
  readonly icon: React.ReactNode;
  readonly label: string;
  readonly totalLabel: string;
  readonly badgeKey1: string;
  readonly badgeVal1: number;
  readonly badgeKey2: string;
  readonly badgeVal2: number;
  readonly status1: MetricStatus;
  readonly status2: MetricStatus;
}

export function OperationalMetricCard(props: OperationalMetricCardProps) {
  const {
    percent,
    color,
    icon,
    label,
    totalLabel,
    badgeKey1,
    badgeVal1,
    badgeKey2,
    badgeVal2,
    status1,
    status2,
  } = props;

  return (
    <OperationalCircleMetric
      percent={percent}
      color={color}
      icon={icon}
      label={label}
      totalLabel={totalLabel}
      badgeKey1={badgeKey1}
      badgeVal1={badgeVal1}
      badgeKey2={badgeKey2}
      badgeVal2={badgeVal2}
      status1={status1}
      status2={status2}
    />
  );
}
